import View from './View';

export { default as View } from './View';
export { default as getSettingsThemeStyles } from './styles';

export default View;
